import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, finalize } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { from, lastValueFrom, Observable, of } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { GenericMessageService } from '../shared/services/messages/generic-message.service';
import {
  COMPONENT_ERROR_HANDLE,
  COMPONENT_LOADER_HANDLE,
} from '../shared/utils/utils';
// import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private totalRequests: number = 0;

  constructor(
    private _loader: NgxUiLoaderService,
    private keycloakService: KeycloakService,
    private genericMessageService: GenericMessageService,
  ) {}

  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler,
  ): Observable<HttpEvent<T>> {
    return this.handle(req, next);
  }

  handle(req: HttpRequest<any>, next: HttpHandler) {
    setTimeout(() => {
      this.totalRequests++;
      if (!req.context.get(COMPONENT_LOADER_HANDLE)) {
        this._loader.start();
      }
    }, 0);

    return next.handle(req).pipe(
      finalize(() => {
        setTimeout(() => {
          this.totalRequests--;
          if (this.totalRequests === 0) {
            if (!req.context.get(COMPONENT_LOADER_HANDLE)) {
              this._loader.stop();
            }
          }
        }, 300);
      }),
      catchError((err: { status: number }) => {
        if (err.status === 401) {
          this.keycloakService.logout();
          return new Observable<HttpEvent<any>>();
        }
        if (err instanceof HttpErrorResponse) {
          if (req.context.get(COMPONENT_ERROR_HANDLE)) {
            // gestione errore nel componente
            throw err;
          } else {
            this.genericMessageService.genericAlertMessageApiError(err);
          }
        }
        return new Observable<HttpEvent<any>>();
      }),
    );

    /*return await lastValueFrom(
      next.handle(req).pipe(
        finalize(() => {
          setTimeout(() => {
            this.totalRequests--;
            if (this.totalRequests === 0) {
              if (!req.context.get(COMPONENT_LOADER_HANDLE)) {
                this._loader.stop();
              }
            }
          }, 300);
        }),
        catchError((err: { status: number }) => {
          if (err.status === 401) {
            this.keycloakService.logout();
            return new Observable<HttpEvent<any>>();
          }
          if (err instanceof HttpErrorResponse) {
            if (req.context.get(COMPONENT_ERROR_HANDLE)) {
              // gestione errore nel componente
              throw err;
            } else {
              this.genericMessageService.genericAlertMessageApiError(err);
            }
          }
          return new Observable<HttpEvent<any>>();
        })
      )
    );*/
  }
}
